import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { PageHeader, DataTable } from "../components/bits";

export default function Audit() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const columns = [
    { key: "timestamp", label: "Fecha/Hora", render: (l) => <span className="font-mono text-xs">{new Date(l.timestamp).toLocaleString("es-DO")}</span> },
    { key: "user_name", label: "Usuario", render: (l) => <span className="font-medium text-slate-900">{l.user_name}</span> },
    { key: "user_role", label: "Rol", render: (l) => <span className="capitalize">{l.user_role}</span> },
    { key: "action", label: "Acción" },
    { key: "detail", label: "Detalle" },
  ];

  return (
    <div data-testid="audit-page">
      <PageHeader title="Registro de Auditoría" subtitle="Trazabilidad de acciones del colegio" />
      <DataTable columns={columns} rows={logs} testid="audit-table" />
    </div>
  );
}
